$(document).ready(function(){
  $(".product-quotes").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 1,
    navText: ["<", ">"]
  });
});


$(document).ready(function(){
  $(".custom-related-products").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 5, // Default item count
    //navText: ["<", ">"],
    responsive: {
      0: {
        items: 2 // Mobile devices
      },
      576: {
        items: 2 // Small devices
      },
      768: {
        items: 3 // Medium devices
      },
      992: {
        items: 3 // Large devices
      },
      1200: {
        items: 4 // Extra large devices
      },
      1400: {
        margin: 0,
        items: 4.5 // Extra large devices
      },
      1550: {
        margin: 0,
        items: 4.5 // Extra large devices
      }
    }
  });
});


// Select the elements to wrap
const priceWrap = document.querySelector('span[data-product-price-wrap]');
const onSalePrice = document.querySelector('span.product__price.on-sale');

// Check if both elements exist
if (priceWrap && onSalePrice) {
  // Create the wrapper div
  const wrapper = document.createElement('div');
  wrapper.className = 'price-wrap';

  // Insert the wrapper before the first element
  priceWrap.parentNode.insertBefore(wrapper, priceWrap);

  // Move the elements inside the wrapper
  wrapper.appendChild(priceWrap);
  wrapper.appendChild(onSalePrice);
}

// Function to wrap the element when it appears
function wrapJudgeMeReviewSpan() {
  const reviewSpan = document.querySelector('span.jdgm-prev-badge__text');

  if (reviewSpan) {
    console.log('Found span: ', reviewSpan);

    // Check if it's already wrapped in an anchor tag
    if (reviewSpan.parentElement.tagName.toLowerCase() !== 'a') {
      const anchor = document.createElement('a');
      anchor.href = '#shopify-block-AZlJwQlZwQlpRM3Bhc__judge_me_reviews_featured_carousel_JMjPUx';
      
      // Log before insertion to check if it's getting inserted correctly
      console.log('Wrapping with anchor:', anchor);

      // Insert the anchor before the span
      reviewSpan.parentNode.insertBefore(anchor, reviewSpan);

      // Append the span inside the anchor tag
      anchor.appendChild(reviewSpan);

      console.log('Judge.me span wrapped in anchor.');
    } else {
      console.log('Span is already wrapped in an anchor.');
    }
  } else {
    // If the span is not found, wrap the text inside the span
    const textContent = document.querySelector('span.jdgm-prev-badge__text')?.textContent;

    if (textContent) {
      const anchor = document.createElement('a');
      anchor.href = '#shopify-block-AZlJwQlZwQlpRM3Bhc__judge_me_reviews_featured_carousel_JMjPUx';
      // Wrap the text inside the anchor
      anchor.textContent = textContent;

      // Find the span's parent to insert the anchor
      const parentElement = document.querySelector('span.jdgm-prev-badge__text').parentNode;
      if (parentElement) {
        parentElement.insertBefore(anchor, parentElement.firstChild);
      }

      console.log('Text wrapped in anchor tag.');
    } else {
      console.log('No text found to wrap.');
    }
  }
}

// Initial delay of 3 seconds before starting to check for the span
setTimeout(function() {
  console.log('Starting the wrap process...');
  // Start polling when the page loads and the 3-second delay has passed
  wrapJudgeMeReviewSpan();
}, 3000); // 3000ms = 3 seconds

// [SC] - 26th Jan 2026 - comparision table
(function () {
  function checkHorizontalOverflow() {
    document.querySelectorAll('.sc-js-overflow-checker').forEach(function (el) {
      if (el.scrollWidth > el.clientWidth) {
        el.classList.add('sc-has-overflow');
      } else {
        el.classList.remove('sc-has-overflow');
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkHorizontalOverflow);
  } else {
    checkHorizontalOverflow();
  }

  // Run on window resize
  window.addEventListener('resize', checkHorizontalOverflow);

  // Run when content changes (dynamic updates)
  const observer = new MutationObserver(function () {
    checkHorizontalOverflow();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

})();

(function () {

  function initTabs() {

    document.querySelectorAll('.sc-tabs').forEach(function (tabGroup) {

      // Prevent double init
      if (tabGroup.dataset.tabsInit) return;
      tabGroup.dataset.tabsInit = 'true';

      const buttons = tabGroup.querySelectorAll('.sc-tab-btn');
      const panels = tabGroup.querySelectorAll('.sc-tab-panel');

      buttons.forEach(function (btn) {

        btn.addEventListener('click', function () {

          const target = btn.getAttribute('data-tab');

          // Remove active classes
          buttons.forEach(b => b.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));

          // Add active
          btn.classList.add('active');

          const panel = tabGroup.querySelector(
            '.sc-tab-panel[data-tab="' + target + '"]'
          );

          if (panel) {
            panel.classList.add('active');
          }

        });

      });

    });

  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }

  // Watch for dynamic content (Shopify sections, AJAX)
  const observer = new MutationObserver(function () {
    initTabs();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


// [SC] - 26th Jan 2026 - compare table | filter
(function () {

  function initFilters(context) {

    const scope = context || document;

    /* ------------------------------
       UPDATE COUNTERS
    ------------------------------ */
    scope.querySelectorAll('.sc-tbl-filter-wrap').forEach(function (wrap) {

      const counter = wrap.querySelector('.sc-filter-dy-count');
      if (!counter) return;

      const checkboxes = wrap.querySelectorAll('input[type="checkbox"]');
      const total = checkboxes.length;
      let checked = 0;

      checkboxes.forEach(cb => { if (cb.checked) checked++; });

      counter.textContent = "(" + checked + "/" + total + ")";
    });

  }

  /* ------------------------------
     GLOBAL CHANGE HANDLER
     (Event Delegation)
  ------------------------------ */
  document.addEventListener('change', function (e) {

    const checkbox = e.target.closest(
      '.sc-tbl-filter-wrap .sc-comp-checkbox input[type="checkbox"]'
    );

    if (!checkbox) return;

    /* --- Toggle matching table rows --- */
    const value = checkbox.value;
    const targets = document.querySelectorAll(
      '[data-tbl-group="' + CSS.escape(value) + '"]'
    );

    targets.forEach(function (el) {
      el.style.display = checkbox.checked ? '' : 'none';
    });

    /* --- Update counter for that wrapper only --- */
    const wrapper = checkbox.closest('.sc-tbl-filter-wrap');
    if (!wrapper) return;

    const counter = wrapper.querySelector('.sc-filter-dy-count');
    if (!counter) return;

    const checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
    const total = checkboxes.length;
    let checked = 0;

    checkboxes.forEach(cb => { if (cb.checked) checked++; });

    counter.textContent = "(" + checked + "/" + total + ")";

  });

  /* ------------------------------
     INIT ON LOAD
  ------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFilters();
    });
  } else {
    initFilters();
  }

  /* ------------------------------
     SUPPORT DYNAMIC CONTENT
  ------------------------------ */
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          initFilters(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
